import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCarComponent } from "./med-icon-car.component";

@NgModule({
  declarations: [
    MedIconCarComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCarComponent,
  ],
})
export class MedIconCarModule { }
